module.exports = __webpack_public_path__ + "img/file-post-fill.0ef3ccff.svg";